import React from 'react';
import * as FiIcons from 'react-icons/fi';
import ErrorBoundary from '@/components/feedback/ErrorBoundary.jsx';
import EmptyState from '@/components/feedback/EmptyState.jsx';
import AgentTile from '@/components/agents/AgentTile.jsx';

const ERROR_ICON = FiIcons.FiAlertTriangle;

/**
 * Responsive agent fleet grid (T2a): auto-fill tiles at ≥240px, wrapped
 * in an ErrorBoundary so one bad tile can never blank the cockpit.
 */
function AgentGrid({ agents, onOpenAgent = null }) {
  return (
    <ErrorBoundary
      fallback={(
        <EmptyState
          icon={ERROR_ICON}
          title="Fleet panel crashed"
          hint="Something went wrong while rendering the agent grid. Dismiss the error to reload it."
        />
      )}
    >
      {agents.length === 0 ? (
        <EmptyState
          icon={FiIcons.FiCpu}
          title="No agents running"
          hint="Your fleet is idle. Launch agents or review queued work to bring them online."
          action={<span className="ghost-button">Review approvals</span>}
        />
      ) : (
        <div className="agent-grid">
          {agents.map((agent) => (
            <AgentTile
              agent={agent}
              key={agent.id}
              {...(onOpenAgent ? { onClick: () => onOpenAgent(agent) } : {})}
            />
          ))}
        </div>
      )}
    </ErrorBoundary>
  );
}

export default AgentGrid;
